import { Col, Form } from "antd";
import moment from "moment";
import CustomDatePicker from "common/CustomDatePicker";

// Fix round 1 (ux-sweep batch 2, finding 1): the visible pickers must show the
// same last-7-days-ending-today window that AbsenteeismReport/index.js's mount
// effect fetches with (its own getDefaultDateRange()). Kept as a literal
// expression here (rather than importing from the page) to avoid a common ->
// feature import; if that page's default ever changes, this must change with it.
const OperatorAbsenteeismFilterFields = () => {
  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          required
          initialValue={moment().subtract(6, "days")}
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          required
          initialValue={moment()}
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default OperatorAbsenteeismFilterFields;
